import api from '@/api/reports';

const actions = {
  FETCH_UNITS_REPORT: async ({ commit, dispatch, state, rootGetters }) => {
    const { organizationId } = rootGetters;

    const {
      dateRange: { start: startDate, end: endDate },
      pageSize,
      currentPage,
      ordering,
      filters: { query: search },
    } = state;

    const offset = currentPage * pageSize;

    const params = {
      organization_id: organizationId,
      limit: pageSize,
      offset,
      ordering,
      search,
      start_date: startDate,
      end_date: endDate,
    };

    dispatch('wait/start', 'unitsReport.fetching', { root: true });

    try {
      const { count, results: report } = await api.fetchUnitsReport(params);

      commit('SET_REPORT', report);
      commit('SET_COUNT', count);

      return report;
    } finally {
      dispatch('wait/end', 'unitsReport.fetching', { root: true });
    }
  },

  DOWNLOAD_UNITS: async ({ state, rootGetters }, { formatType }) => {
    const { organizationId } = rootGetters;
    const {
      dateRange: { start: startDate, end: endDate },
      pageSize,
      currentPage,
      ordering,
      filters: { query: search },
    } = state;
    const fields = state.columns.filter(x => x.showColumn).map(x => x.source_field);

    await api.fetchUnitsReport({
      organization_id: organizationId,
      pageSize,
      currentPage,
      ordering,
      search,
      start_date: startDate,
      end_date: endDate,
      format: formatType,
      include: fields,
    });
  },

  DATE_RANGE_UPDATE: ({ commit, dispatch }, dateRange) => {
    commit('SET_DATE_RANGE', dateRange);
    commit('SET_CURRENT_PAGE', { currentPage: 0 });
    dispatch('FETCH_UNITS_REPORT');
  },
};

export default actions;
